'use client';
export const runtime = 'edge';

import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Content } from '@/components/Content';
import { usePathname } from 'next/navigation';

// Erstellen einer erweiterten Content-Komponente mit Framer Motion
const MotionContent = motion.create(Content);

export default function Template({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  
  return (
    <AnimatePresence mode="wait">
      <MotionContent>
        <motion.div
          key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.6, ease: "easeOut" } }}
          exit={{ opacity: 0, transition: { duration: 0.25, ease: "easeIn" } }}
        >
          {children}
        </motion.div>
      </MotionContent>
    </AnimatePresence>
  );
}